// CharterWorkbench — per-agent wrapper over <CompositionWorkbench> for
// CHARTER, the investment-trust reporting composer. CHARTER emits exactly
// one canonical variant.

import CompositionWorkbench from '.';
import { compositionAgentConfig } from './composition-agent-config';
import type { BaseDraft } from '@/data/types';

interface CharterWorkbenchProps {
    draft: BaseDraft;
    readOnly?: boolean;
    onApproved?: (draft: BaseDraft) => void;
    onRejected?: (draft: BaseDraft) => void;
    onRevisionRequested?: (draft: BaseDraft) => void;
}

export default function CharterWorkbench({
    draft,
    readOnly,
    onApproved,
    onRejected,
    onRevisionRequested,
}: CharterWorkbenchProps) {
    return (
        <CompositionWorkbench<BaseDraft>
            agentName="CHARTER"
            draft={draft}
            table={compositionAgentConfig.CHARTER.table}
            actions={compositionAgentConfig.CHARTER.actions}
            readOnly={readOnly}
            onApproved={onApproved}
            onRejected={onRejected}
            onRevisionRequested={onRevisionRequested}
        />
    );
}
